import apiManager from './manager/api-manager'
import { getApiKey } from '@/utils/api-signature'
import { getEnvValue } from '@/utils/env-config'
import { DEFAULT_CLIENT_SIDE_KEY_ROUTE, fetchClientSideKey } from './bff/maps'

/** 直連後端的地圖介面（只有應急方案才會用到） */
const DIRECT_CLIENT_SIDE_KEY_URL = '/api/google/maps/v1/client-side-key'

/** 明確要求「地圖 key 走自家 BFF」的字串值 */
const USE_BFF_VALUES = ['1', 'true', 'yes', 'on']

/**
 * 是否強制地圖 key 走自家 BFF。
 * 由執行時配置 MAP_KEY_USE_BFF（或構建時 VUE_APP_MAP_KEY_USE_BFF）決定：
 * 開啟後即使配置了 API_SIGNATURE_KEY（瀏覽器可自行簽名），地圖 key 仍由 BFF 代簽名取得，
 * 符合後端文檔第 1、5 節「瀏覽器不能持有共享密鑰」的要求。
 */
function shouldUseBff() {
  const value = getEnvValue('MAP_KEY_USE_BFF', 'VUE_APP_MAP_KEY_USE_BFF')
  return USE_BFF_VALUES.indexOf(String(value).trim().toLowerCase()) !== -1
}

export default {

  /**
   * 取得 Google Maps 前端 key。
   *
   * 鏈路選擇：
   * 1) MAP_KEY_USE_BFF 開啟 → 一律走自家 BFF（文檔建議做法，瀏覽器不含密鑰）；
   * 2) 否則若配置了 API_SIGNATURE_KEY（構建時 .env.* 或執行時 env-config.js）
   *    → 瀏覽器直連後端並自行簽名，該鏈路偏離文檔的安全建議（密鑰會進入瀏覽器）；
   * 3) 都沒配置 → 走自家 BFF，行為與接入簽名前一致。
   *
   * 各環境的密鑰對照見 README「環境區分」；BFF 部署見 bff/README.md。
   */
  clientSideKey() {
    if (!shouldUseBff() && getApiKey()) {
      return apiManager.get({ url: DIRECT_CLIENT_SIDE_KEY_URL })
    }
    const bffPath = getEnvValue('MAP_KEY_BFF_PATH', 'VUE_APP_MAP_KEY_BFF_PATH')
    return fetchClientSideKey(bffPath || DEFAULT_CLIENT_SIDE_KEY_ROUTE)
  }
}
